import { Map } from 'immutable';

import { contactDetails } from './types';

export * from './actions';

const contactDetailsReducerObject = {
  [contactDetails.request]: (state, action) =>
    state.setIn(
      ['fundingSearchContactDetails', action.fundingSearchId, 'network', 'loading'],
      true,
    ),
  [contactDetails.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchContactDetails', action.fundingSearchId, 'network', 'loading'], false)
        .setIn(['fundingSearchContactDetails', action.fundingSearchId, 'network', 'error'], false)
        .setIn(
          ['fundingSearchContactDetails', action.fundingSearchId, 'data'],
          Map(action.response),
        ),
    ),
  [contactDetails.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['fundingSearchContactDetails', action.fundingSearchId, 'network', 'loading'], false)
        .setIn(
          ['fundingSearchContactDetails', action.fundingSearchId, 'network', 'error'],
          action.error,
        ),
    ),
};

export default contactDetailsReducerObject;
